export const funnelStageOptions = [
  { value: 'reached_chatbot', label: 'Reached chatbot' },
  { value: 'completed_onboarding', label: 'Completed onboarding' },
  { value: 'answer_intent', label: 'Answer intent' },
  { value: 'engage_with_content', label: 'Engage with content' },
  { value: 'referral', label: 'Referral' },
  { value: 'redemption', label: 'Redemption' }
]

// Funnel stages that already have a real, enforced equivalent in the live count payload.
// Any funnel stage not listed here is captured on the saved segment but not yet applied to the live count.
export const funnelStageBackendMap = {
  completed_onboarding: { onboardStatus: [1] },
  referral: { referralStatus: 1 }
}

const AGE_MIN = 15
const AGE_MAX = 65 // top bucket is open-ended: "65+"
const AGE_BRACKETS = []
for (let age = AGE_MIN; age < AGE_MAX; age++) AGE_BRACKETS.push(age)

export const ageOptions = [
  { id: '', label: 'Any' },
  ...AGE_BRACKETS.map(age => ({ id: age, label: String(age) })),
  { id: AGE_MAX, label: '65+' }
]

const RECENCY_DAYS = [1, 2, 3, 5, 7, 14, 21, 30, 60, 90, 365]
export const recencyOptions = [
  { id: '', label: 'Any' },
  ...RECENCY_DAYS.map(d => ({ id: d, label: `${d} day${d === 1 ? '' : 's'}` })),
  { id: 'all_time', label: 'All time' }
]

export const barrierOptions = [
  { value: 'cost_affordability', label: 'Cost / affordability' },
  { value: 'distance_access', label: 'Distance or access' },
  { value: 'stigma', label: 'Stigma' },
  { value: 'lack_of_awareness', label: 'Lack of awareness' },
  { value: 'partner_opposition', label: 'Partner opposition' },
  { value: 'side_effects_fear', label: 'Side effects fear' }
]

export const radiusOptions = [
  { id: '', label: 'Any distance' },
  { id: 1, label: 'Within 1 km' },
  { id: 2, label: 'Within 2 km' },
  { id: 5, label: 'Within 5 km' },
  { id: 10, label: 'Within 10 km' },
  { id: 20, label: 'Within 20 km' },
  { id: 30, label: 'Within 30 km' },
  { id: 50, label: 'Within 50 km' }
]

// Fields for which the live count/backend genuinely honors the value today.
// Everything else is best-effort: captured on the saved segment, shown with a
// "not yet enforced" note, and passed through defensively on the count call.
export const FUNCTIONAL_FIELDS = [
  'country_id', 'channels', 'gender', 'minAge', 'maxAge', 'journey',
  'entryKeywords', 'activeConversationExclude'
]



// WEBPACK FOOTER //
// ./src/components/audience-builder/ai-audience/constants.js